// MODULES
import React from "react";
// HELPERS
import {createClassName} from "@helpers/utils";
import EditableField from "../../../components/EditableField/EditableField";
import fulfillmentCheck from "./Autogiro.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import CheckboxWithName from "../../../components/CheckboxWithName/CheckboxWithName";
import NumberField from "../../../components/NumberField/NumberField";
import AbstractAutogiro from "../AbstractAutogiro";
import Select from "../../../../../components/Select/Select";
import Validator from "../../../../../classes/Validator";
import Checkbox from "../../../../../components/Checkbox/Checkbox";


export default class Autogiro extends AbstractAutogiro {

	static minimumAmountSingleDeposit = 0;
	static minimumAmountMonthlyDeposit = 0;

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {state, props} = this;
		const {availableBanks} = props;
		const {fields, validFields} = state;

		const classes = createClassName("Cob-Autogiro-Odin", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled
		});

		const textClasses = createClassName("description", {
			"contractable": true,
			"expanded": state.textFieldExpanded
		});

		const textClassSingle = createClassName("payments-details", {
			"expanded": state.fields.checkbox_autogiro_single.checked
		});

		const textClassMonthly = createClassName("payments-details", {
			"expanded": state.fields.checkbox_autogiro_monthly.checked
		});

		/**
		 * Set up the dropdown with selectable banks.
		 */
		let availableBankOptions = [];
		for (const bankName in availableBanks) {
			if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) continue;
			availableBankOptions.push({
				label: bankName,
				value: bankName
			});
		}

		availableBankOptions.push({
			label: "Övriga",
			value: "-"
		});

		let selectedBankIndex = -1;

		if (state.fields.customer_autogiro_bank && state.fields.customer_autogiro_bank.length > 0) {
			let bankFoundInList = false;
			for (const bankName in availableBanks) {
				if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) {
					continue;
				}
				selectedBankIndex++;
				if (bankName === state.fields.customer_autogiro_bank) {
					bankFoundInList = true;
					break;
				}
			}

			if (!bankFoundInList && state.fields.customer_autogiro_bank === '-') {
				selectedBankIndex++;
			}
		}

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<h2 style={{margin: "0"}}>Autogiromedgivande / Föranmält konto</h2>

				<div className={textClasses}>
					<p>
						Undertecknad (”betalaren”), medger att betalning får göras genom uttag från angivet konto eller
						av betalaren senare angivet Konto, på begäran av angiven betalningsmottagare för betalning till
						denne på viss dag (”förfallodagen”) via Autogiro. Betalaren medger att insättning och uttag från
						angivet konto eller av betalaren föranmält konto får göras på begäran av betalaren. Betalaren
						samtycker till att behandling av personuppgifter som lämnats i detta medgivande behandlas av
						betalarens betaltjänstleverantör, betalningsmottagaren, betalningsmottagarens
						betaltjänstleverantör och Bankgirocentralen BGC AB för administration av tjänsten.
						Personuppgiftsansvariga för denna personuppgiftsbehandling är betalarens betaltjänstleverantör,
						betalningsmottagaren samt betalningsmottagarens betaltjänstleverantör. Betalaren kan när som
						helst begära att få tillgång till eller rättelse av personuppgifterna genom att kontakta
						betalarens betaltjänstleverantör. Ytterligare information om behandling av personuppgifter i
						samband med betalningar kan finnas i villkoren för kontot och i avtalet med
						betalningsmottagaren. Betalaren kan när som helst återkalla sitt samtycke, vilket medför att
						tjänsten i sin helhet avslutas.
					</p>
					<div className="expand">
						<div className="first"></div>
						<div className="second"></div>
						<div className="third" onClick={this._onExpandText}>Expandera texten</div>
					</div>
					<div className="contract" onClick={this._onExpandText}>
						Minimera texten
					</div>
				</div>

				{fields.radio_autogiro_source === "konto" && (
					<React.Fragment>
						<div style={{width: "100%", flexDirection: "row", margin: "15px 0 5px 0"}}>
							<Select
								name="customer_autogiro_bank"
								label="Bank"
								style={{width: "45%", marginRight: "10px"}}
								selectedIndex={selectedBankIndex}
								options={availableBankOptions}
								onChange={this._onSelectBankChange}
							/>

							{fields.customer_autogiro_bank === '-' && (
								<React.Fragment>
									<EditableField
										name="customer_account_bank_custom"
										label="Bankens namn"
										style={{width: "45%"}}
										value={fields.customer_account_bank_custom || ""}
										valid={validFields.customer_account_bank_custom}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
									/>
									<input type="hidden" name="customer_autogiro_bank"
										   value={fields.customer_account_bank_custom}/>
								</React.Fragment>
							)}

							{fields.customer_autogiro_bank !== '-' && (
								<input type="hidden" name="customer_account_bank_custom" value=""/>
							)}
						</div>

						{fields.customer_autogiro_bank === 'Swedbank' && (
							<p style={{
								background: "#FFFFD5",
								padding: "10px",
								fontSize: "12px",
								margin: "10px 0",
								maxWidth: "600px"
							}}>
								Det förekommer att Swedbank har en femte siffra i clearingnumret. Vänligen ange
								enbart de fyra första innan bindestrecket. Exempel: 8214-9 ska anges som 8214.
							</p>
						)}

						<div style={{width: "100%", flexDirection: "row", margin: "5px 0", flexWrap: "wrap"}}>
							<EditableField
								name="customer_autogiro_bank_clearingno"
								style={{width: "45%", marginRight: "10px"}}
								label="Clearingnummer"
								value={fields.customer_autogiro_bank_clearingno || ""}
								valid={validFields.customer_autogiro_bank_clearingno}
								onChange={this._onClearingFieldChange}
								onBlur={this._onFieldBlur}
							/>

							<EditableField
								name="customer_autogiro_bankno"
								style={{width: "45%"}}
								label="Kontonummer"
								value={fields.customer_autogiro_bankno || ""}
								valid={validFields.customer_autogiro_bankno}
								onChange={this._onAccountFieldChange}
								onBlur={this._onFieldBlur}
							/>

							{fields.shouldValidateBankAccount && (
								<Checkbox
									label="Tillåt kontonummer som inte validerar"
									checked={fields.skipBankAccountValidation}
									style={{width: "100%", justifyContent: "flex-start", marginTop: "10px"}}
									onChange={(checked) => {
										this.setState({
											fields: {
												...this.state.fields,
												skipBankAccountValidation: checked
											}
										});
									}}
								/>
							)}

							<input type="hidden" name="customer_account_clearing_no"
								   value={fields.customer_autogiro_bank_clearingno || ""}/>
						</div>
					</React.Fragment>
				)}

				{fields.radio_autogiro_source === "bankgiro" && (
					<React.Fragment>
						<EditableField
							name="customer_autogiro_custno"
							style={{width: "45%", marginTop: "20px"}}
							label="Bankgironummer"
							value={fields.customer_autogiro_custno || ""}
							valid={validFields.customer_autogiro_custno}
							onChange={this._onBankgiroFieldChange}
							onBlur={this._onFieldBlur}
						/>
					</React.Fragment>
				)}

				<div className="payments">
					<CheckboxWithName
						label="Jag vill göra en engångsinsättning via Autogiro"
						name="checkbox_autogiro_single"
						value={(fields.checkbox_autogiro_single.checked) ? "yes" : "no"}
						checked={fields.checkbox_autogiro_single.checked}
						onChange={this._onCheckboxChange}
					/>

					<div className={textClassSingle}>
						<div className="inner">
							<div className="amountField" style={{margin: "10px 0 0 30px"}}>
								<EditableField
									name="customer_autogiro_amount_onetime"
									label="Belopp"
									className="amount"
									Component={NumberField}
									value={fields.customer_autogiro_amount_onetime || ""}
									valid={validFields.customer_autogiro_amount_onetime && fields.customer_autogiro_amount_onetime >= Autogiro.minimumAmountSingleDeposit}
									onChange={this._onFieldChange}
									onBlur={this._onFieldBlur}
								/>
							</div>
						</div>
					</div>

					<CheckboxWithName
						label="Jag vill starta en periodisk dragning via Autogiro"
						name="checkbox_autogiro_monthly"
						value={(fields.checkbox_autogiro_monthly.checked) ? "yes" : "no"}
						checked={fields.checkbox_autogiro_monthly.checked}
						onChange={this._onCheckboxChange}
					/>

					<div className={textClassMonthly}>
						<div className="inner">
							<div className="amountField" style={{margin: "10px 0 10px 30px"}}>
								<EditableField
									name="customer_autogiro_amount_recurring"
									label="Belopp"
									className="amount"
									Component={NumberField}
									value={fields.customer_autogiro_amount_recurring || ""}
									valid={validFields.customer_autogiro_amount_recurring && fields.customer_autogiro_amount_recurring >= Autogiro.minimumAmountMonthlyDeposit}
									onChange={this._onFieldChange}
									onBlur={this._onFieldBlur}
								/>
							</div>

							<Select
								name="radio_autogiro_recurring"
								label="Dragningsfrekvens"
								style={{width: "45%", marginLeft: "30px"}}
								selectedIndex={fields.radio_autogiro_recurring_index}
								options={[
									{
										label: "Månadsvis",
										value: "monthly"
									},
									{
										label: "Kvartalsvis",
										value: "quarterly"
									},
									{
										label: "Halvårsvis",
										value: "half-yearly"
									},
									{
										label: "Årsvis",
										value: "yearly"
									}]}
								onChange={this._onSelectMonthlyChange}
							/>

							<div className="amountField" style={{
								margin: "20px 0 10px 30px",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#f9f9f9",
								padding: "10px",
								width: "500px"
							}}>
								<h4 style={{margin: "5px 0"}}>Antal dragningar totalt</h4>
								<p style={{margin: "0 0 10px 0"}}>
									Lämnas fältet tomt sker de periodiska dragningarna tillsvidare.
								</p>
								<EditableField
									name="customer_autogiro_amount_quantity"
									label="Ange antal"
									Component={NumberField}
									value={fields.customer_autogiro_amount_quantity || ""}
									valid={fields.customer_autogiro_amount_quantity === '' || fields.customer_autogiro_amount_quantity > 0}
									onChange={this._onFieldChange}
									onBlur={this._onFieldBlur}
								/>
							</div>
						</div>
					</div>
				</div>
				<div style={{width: "100%", display: "block"}}>
					<div style={{marginTop: "20px", alignItems: "flex-start"}}>
						<h4 style={{marginBottom: "10px"}}>Till konto</h4>

						<div style={{alignItems: "flex-start", flexDirection: "row", width: "100%"}}>
							<div style={{width: "50%", alignItems: "flex-start"}}>
								<Select
									name="house_bgno"
									label="Bankgiro Fair"
									style={{width: "90%"}}
									selectedIndex={fields.house_bgno_index}
									options={[
										{
											label: "Depå (876-8228)",
											value: "876-8228"
										},
										{
											label: "Fond (5498-3614)",
											value: "5498-3614"
										}]}
									onChange={this._onSelectBgChange}
								/>
							</div>

							<div style={{width: "50%", alignItems: "flex-start"}}>
								<EditableField
									name="customer_accountno_fair"
									style={{width: "90%"}}
									label="Kundens depå-/ISK-nummer hos Fair"
									value={fields.customer_accountno_fair || ""}
									valid={validFields.customer_accountno_fair}
									disabled={fields.radio_new_isk === "yes"}
									onChange={this._onFieldChange}
								/>
								<Checkbox
									label="Öppna ny depå"
									name="radio_new_isk"
									checked={fields.radio_new_isk === "yes"}
									value={"yes"}
									style={{width: "100%", justifyContent: "flex-start", marginTop: "10px"}}
									onChange={(checked) => {
										this.setState({
											fields: {
												...this.state.fields,
												radio_new_isk: checked ? "yes" : "no"
											}
										});
									}}
								/>

								{(fields.radio_new_isk === "yes") && (
									<input type="hidden" name="customer_accountno_fair" value="" />
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	_onSelectBankChange = (option) => {

		let shouldValidateAccountNumber = false;
		const availableBanks = this.props.availableBanks;
		for (const bankName in availableBanks) {
			if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) continue;

			if (option.value === bankName) {
				const bankInfo = availableBanks[bankName];
				if (bankInfo.length > 0) {
					if (bankInfo[0]['validationEnabled'] === "1") {
						shouldValidateAccountNumber = true;
					}
				}
				break;
			}
		}

		this.setState({
			fields: {
				...this.state.fields,
				customer_autogiro_bank: option.value,
				shouldValidateBankAccount: shouldValidateAccountNumber
			}
		});
	};

	_onSelectBgChange = (option, index) => {
		const val = option.value;

		this.setState({
			fields: {
				...this.state.fields,
				house_bgno: {...this.state.fields["house_bgno"], val},
				house_bgno_index: index
			}
		});
	};

	_onSelectMonthlyChange = (option, index) => {
		const val = option.value;

		this.setState({
			fields: {
				...this.state.fields,
				radio_autogiro_recurring: {...this.state.fields["radio_autogiro_recurring"], val},
				radio_autogiro_recurring_index: index
			}
		});
	};

	_onExpandText = () => {
		this.setState({
			textFieldExpanded: !this.state.textFieldExpanded
		});
	};

	_onClearingFieldChange = (name, value) => {
		// Remove all non-numbers
		value = value.replace(/[^0-9]+/g, "");

		// Limit clearing numbers to 4 numbers, we'll show a message that says to enter only first four for the
		// banks with longer numbers
		if (value.length >= 4) {
			value = value.substring(0, 4);
		}

		let valid = (this.state.fields.customer_autogiro_bank === '-') ?
			true :
			Validator.validateClearingNumber(value, this.state.fields.customer_autogiro_bank, this.props.availableBanks);

		CobHelpers.onViewFieldChange.call(this, name, value, valid);
	};

	_onAccountFieldChange = (name, value) => {
		// Remove dashes
		value = value.replace("-", "");
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onBankgiroFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldChange = (name, value) => {
		/**
		 * For the single deposit and monthly savings field treat zero as if the value has not been entered
		 */
		if ((name === 'customer_autogiro_amount_onetime' || name === 'customer_autogiro_amount_recurring') && value === "0") {
			value = "";
		}
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};

	_onFieldBlur = (name) => {
		if (name === 'customer_autogiro_bank_clearingno') {
			CobHelpers.onViewFieldBlur.call(this, name, null, true);
		}
		else {
			CobHelpers.onViewFieldBlur.call(this, name);
		}
	};

	_fieldValidator = (name, value) => {
		if (name === 'customer_autogiro_bankno') {
			/**
			 * For the banks where we know the validation rules, check if the number should be validated.
			 */
			let shouldValidateAccountNumber = false;
			const availableBanks = this.props.availableBanks;
			for (const bankName in availableBanks) {
				if (bankName === 'length' || !availableBanks.hasOwnProperty(bankName)) continue;

				if (this.state.fields.customer_autogiro_bank === bankName) {
					const bankInfo = availableBanks[bankName];
					if (bankInfo.length > 0) {
						if (bankInfo[0]['validationEnabled'] === "1") {
							shouldValidateAccountNumber = true;
						}
					}
					break;
				}
			}

			return this._isValidBankAccountNo(shouldValidateAccountNumber, value, this.state.fields.customer_autogiro_bank_clearingno);
		}

		return value.length > 0;
	};
}

// PRIVATE FUNCTIONS
function _getFields() {
	return [
		"customer_autogiro_bank",
		"house_bgno",
		"customer_account_bank_custom",
		"customer_autogiro_bankno",
		"customer_autogiro_bank_clearingno",
		"customer_accountno_fair",
		"customer_autogiro_amount_quantity",

		"checkbox_autogiro_single",
		"customer_autogiro_amount_onetime",

		"checkbox_autogiro_monthly",
		"radio_autogiro_source",
		"customer_autogiro_amount_recurring"
	];
}

function _getInitialState() {
	if (this.props.prevState) {
		return {...this.props.prevState};
	}

	return {
		textFieldExpanded: false,
		fields: {
			"shouldValidateBankAccount": false,
			"skipBankAccountValidation": false,
			"radio_new_isk": "no",
			"customer_autogiro_bank": "",
			"house_bgno": "",
			"house_bgno_index": -1,
			"radio_autogiro_recurring": -1,
			"radio_autogiro_recurring_index": -1,
			"customer_account_bank_custom": "",
			"customer_autogiro_bankno": "",
			"customer_autogiro_bank_clearingno": "",
			"customer_accountno_fair": "",
			"radio_autogiro_source": "konto",
			"customer_autogiro_custno": "",
			"customer_autogiro_amount_quantity": "",

			"checkbox_autogiro_single": {
				checked: false
			},
			"customer_autogiro_amount_onetime": "",

			"checkbox_autogiro_monthly": {
				checked: false
			},
			"customer_autogiro_amount_recurring": ""
		},
		validFields: {}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Autogiro/fair-ag/Autogiro.js